import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Mode } from '../../rl-common/shared/shared/types/mode';
import { Assignment } from '../shared/assignment';

@Component({
  selector: 'rl-assignment-brief',
  templateUrl: './assignment-brief.component.html',
  styleUrls: ['./assignment-brief.component.scss', './assignment-brief.component-rtl.css']
})
export class AssignmentBriefComponent implements OnInit{

  @Input('assignment') asgmt : Assignment;
  @Input() mode : Mode;

  @Output() onDelete = new EventEmitter<void>();

  editMode : boolean;

  constructor() { }

  ngOnInit(): void {
    this.editMode = this.mode == "edit";
  }

  openAssignment = () : void => {
    location.href = './assignments/' + this.asgmt.id;
  }
}
